import { render, staticRenderFns } from "./MapStartIcon.vue?vue&type=template&id=3f8cd20c&scoped=true"
import script from "./MapStartIcon.vue?vue&type=script&lang=js"
export * from "./MapStartIcon.vue?vue&type=script&lang=js"
import style0 from "./MapStartIcon.vue?vue&type=style&index=0&id=3f8cd20c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8cd20c",
  null
  
)

export default component.exports